import { render, staticRenderFns } from "./TraxTrainingCourseEditItemForm.vue?vue&type=template&id=6caf92e0"
import script from "./TraxTrainingCourseEditItemForm.vue?vue&type=script&lang=js"
export * from "./TraxTrainingCourseEditItemForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports